export enum EnrollmentInformationStatus {
  PENDING = 'PENDING',
  TO_BE_COMPLETED = 'TO_BE_COMPLETED',
  COMPLETED = 'COMPLETED'
}
